import React from "react";
import styled from "styled-components";

const Wrapper = styled.p.attrs(({className: "account-title"}))`
  align-self: center;
`;

export function AccountTitle({ arrears, accountNumber }) {
  return (
    <Wrapper>
      ACCOUNT ID{" "}
      <span className={`bold-green ${arrears ? "light-green" : ""}`}>
        {accountNumber}
      </span>
    </Wrapper>
  );
}
